module.exports = __webpack_public_path__ + "img/account-primary.bf31dac7.svg";